import AppEditorMixin from "@/protected/mixins/AppEditorMixin";
import service from "./TagService";
import TagForm from "./TagForm";

export default {
  mixins: [AppEditorMixin],

  created() {
    this.tabs = [
      {
        component: TagForm,
        title: () => this.$t("tag.tabs.main"),
        icon: "tag"
      }
    ];
  },

  methods: {
    getService() {
      return service;
    }
  }
};
